import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { LuPaperclip } from 'react-icons/lu';
import Loader from '@@/components/Loader';
import { useGetEventsQuery } from '@@/services/event';
import { translateSpeciality } from '@@/constants/practitioner';
import { conversationUrlFor } from '@@/utils/conversation';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

const CalendarPage: React.FC = () => {
  const navigate = useNavigate();
  const { data: events, isLoading } = useGetEventsQuery();

  if (isLoading) {
    return (
      <div className="m-8 flex flex-row items-center justify-center w-full">
        <Loader />
        <p className="ml-2 font-main text-main text-lg">Chargement...</p>
      </div>
    );
  }

  return (
    <Calendar
      className="m-4"
      localizer={localizer}
      events={events?.map((event) => ({
        id: event.id,
        title: event.userId?.firstName ? (
          <p className="flex flex-row items-center cursor-pointer">
            {event.attachmentIds?.map((_, i) => (
              <LuPaperclip key={i} className="mr-0.5" />
            ))}
            <span>
              [{event.userId.firstName.slice(0, 1)}. {event.userId.lastName}
              ]&nbsp;-&nbsp;{event.name}&nbsp;
              {!event.doctolibId && event.targetPractitioner?.speciality
                ? `(${translateSpeciality(event.targetPractitioner.speciality)})`
                : ''}
            </span>
          </p>
        ) : (
          <p>{event.name}</p>
        ),
        start: moment(event.startDate).toDate(),
        end: moment(event.endDate || event.startDate).toDate(),
        userId: event.userId,
        url: event.url,
      }))}
      startAccessor="start"
      endAccessor="end"
      defaultView="agenda"
      messages={{
        week: 'Semaine',
        work_week: 'Semaine de travail',
        day: 'Jour',
        month: 'Mois',
        previous: 'Antérieur',
        next: 'Prochain',
        today: `Aujourd'hui`,
        agenda: 'Ordre du jour',
        showMore: (total) => `+${total} plus`,
      }}
      onSelectEvent={(event) => {
        if (event.url) {
          window.open(event.url, 'newtab');
        } else if (event.id) {
          const patientId = event.userId._id;
          navigate(`/patients/${patientId}/events/${event.id}`);
        } else {
          navigate(
            conversationUrlFor({
              id: event.userId._id,
              conversationId: event.userId.conversationId,
            }),
          );
        }
      }}
    />
  );
};

export default CalendarPage;
